export default function findTreeItems(tree, matcher, options = {}) {
  let { childrenKey = "items" } = options;
  let items = [];
  tree.forEach((item) => {
    if (matcher(item)) {
      items.push(item);
    }
    if (item[childrenKey]) {
      items = items.concat(findTreeItems(item[childrenKey], matcher, options));
    }
  });
  return items;
}
